import React from 'react';
import Button from '../UI/Button/Button';

import './ProjectButton.scss'

const ProjectButton = props => {
  const {projectName, isProjectDisabled, onClick, selectedProject} = props

  return (
    <Button
      btnId={projectName}
      key={projectName}
      disabled={isProjectDisabled}
      onClick={isProjectDisabled ? () => {} : () => {onClick(projectName)}}
      className={`project-button ${selectedProject == projectName ? 'selected-project' : ''}`}
    >
      <div className="request-button-container">
        <label>{projectName}</label>
        {/* {!!projects[projectName].GroupProjectName && (
          <label className={`grouping-label h6 ${selectedProject == projectName ? 'selected-project' : ''}`}>
            {projects[projectName].GroupProjectName}
          </label>
        )} */}
        {/* {isProjectDisabled && buttonsText[projectName] && getRequestButton(projectName)} */}
      </div>
    </Button>
  );
};

export default ProjectButton;
